

import Navbar from "./Navbar";
import ImportantDatesTicker from "./ImportantDatesTicker";
import HeroSection from "./HeroSection";
import IndustriesRow from "./IndustriesRow";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import WhyChooseUs from "./WhyChooseUs";
import UpdatesSection from "./UpdatesSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

export default function Home() {
  return (
    <div className="bg-background text-on-background font-manrope selection:bg-secondary-fixed selection:text-on-secondary-fixed">
      <Navbar />
      <ImportantDatesTicker />
      <HeroSection />
      <IndustriesRow />
      <AboutSection />
      <ServicesSection />
      <WhyChooseUs />
      <UpdatesSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
